<script>
  import {getContext} from 'svelte';
  import {envUtil} from '@/helper/env';
  import {genAppStoreUrl, genGoogleAPKPlayUrl, genGooglePlayUrl} from '@/helper/download';
  import {IMAGES} from '../images';
  import {lang$} from '@/store';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  $: downloadBtns = [
    {
      url: genAppStoreUrl(),
      label: LG(lang.AppStore),
      img: envUtil.isMobile ? IMAGES.H5_APPLE : IMAGES.APPLE,
      imgNew: 'https://img.phemex.com/v1/667e0b0d-159b-4474-a587-6025056bdcb8/vector.svg',
    },
    {
      url: genGooglePlayUrl(),
      label: LG(lang.GooglePlay),
      img: envUtil.isMobile ? IMAGES.H5_GOOGLE_PLAY : IMAGES.GOOGLE_PLAY,
      imgNew: 'https://img.phemex.com/v1/bee8e695-ecbe-4197-9ae9-b5b4d77c21de/home-download-google-play-svg.svg',
    },
    {
      url: genGoogleAPKPlayUrl(),
      label: LG(lang.DownloadAPK),
      imgNew: 'https://img.phemex.com/v1/d738042a-eb48-40f0-8389-0e8ec65f05b3/android-2.svg',
    },
  ];

  function bntClickHandler(url) {
    return function () {
      window.open(url, '_blank', 'noopener');
    };
  }
</script>

<style>
  .outer {
    margin-top: 100px;
  }
  .wrap {
    margin: 0 auto;
    width: 1200px;
  }
  .content {
    height: 558px;
    gap: 40px;
    transform: translateX(40px);
  }
  .h-full {
    height: 100%;
  }
  .left {
    box-sizing: border-box;
    padding: 44px 0;
    width: 50%;
  }
  .caption {
    margin-top: 0;
    margin-bottom: 0;
    line-height: 56px;
    font-weight: 700;
    font-size: 48px;
    font-family: gilroy-bold;
  }
  .caption-es {
    font-size: 40px;
  }
  .caption-ru {
    font-size: 42px;
  }
  .c-gray {
    color: #888b94;
  }
  .desc {
    width: 500px;
  }
  .download-btn {
    border: 1px solid #57585c;
    padding: 12px 14px;
    background: transparent;
    cursor: pointer;
    transition: opacity 0.3s;
  }
  .download-btn:hover {
    opacity: 0.7;
  }
  .download-btn img {
    height: 24px;
  }
  .mt60 {
    margin-top: 60px;
  }
  .qrcode {
    box-sizing: border-box;
    border-radius: 26px;
    padding: 16px;
    width: 180px;
    height: 180px;
    background: #fff;
  }
  .gap-24 {
    gap: 24px;
  }
  @media screen and (max-width: 640px) {
    .outer {
      margin-top: 40px;
    }
    .wrap {
      padding: 0 16px;
      width: auto;
    }
    .caption {
      margin-bottom: 16px;
      font-size: 18px;
    }
    .sub-title {
      margin-bottom: 20px;
    }
    .content {
      flex-direction: column-reverse;
      align-items: center;
      height: auto;
      transform: unset;
    }
    .content .left {
      margin-top: 0;
      padding: 0;
      width: 100%;
      text-align: center;
    }
    .content .right {
      width: 66%;
    }
    .content .right img {
      width: 100%;
      height: auto;
    }
    .caption {
      margin-bottom: 0;
      line-height: 22px;
      font-size: 18px;
    }
    .caption-desc {
      font-weight: 400;
      font-size: 14px !important;
    }
    .qrcode {
      margin-top: 20px;
      border-radius: 20px;
      padding: 16px 20px;
      background: #f9f9f9;
    }
    .download-wrap {
      margin-top: 20px;
    }
    .download-wrap button img {
      width: 24px;
      height: 24px;
    }
    .btns-wrap {
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 0;
      padding: 0 20px;
      gap: 8px;
    }
    .download-btn img {
      width: 16px !important;
      height: 16px !important;
    }
    .download-btn span {
      margin-left: 8px;
      font-weight: 500;
      font-size: 12px;
    }
  }
</style>

<section class="outer">
  <div class="wrap">
    <div class="df content">
      <div class="left TW h-full">
        <h2 class="caption" class:caption-es={$lang$ === 'es'} class:caption-ru={$lang$ === 'ru'}>{LG(lang.TradeCrypto)}</h2>
        <div class="c-gray fw2 f16 mt15 caption-desc">{LG(lang.ScanToDownloadIOSAndroid)}</div>
        <div class="sub-title c-gray f16 fw2 caption-desc">{LG(lang.TradeCryptocurrenciesWith)}</div>
        <div class="tc dn xs:db">
          <img class="usn" width="66%" src="https://img.phemex.com/v1/1c70e7b2-d0f3-45ad-9e1b-f43ad5536dad/frame-1000005793.png" alt="crypto trading platform" />
        </div>
        <div class="download-wrap mt60">
          <div class="qrcode df aife xs:dn">
            <img class="usn" width="100%" height="100%" src={IMAGES.DOWNLOAD_QRCODE} alt="QR code to download the app" />
          </div>
          <div class="btns-wrap df aic gap-24 mt40">
            {#each downloadBtns as btn}
              <button class="df aic br8 download-btn" on:click={bntClickHandler(btn.url)}>
                <img class="usn" src={btn.imgNew} alt="" />
                <span class="f16 fw3 TW ml12">{btn.label}</span>
              </button>
            {/each}
          </div>
        </div>
      </div>
      <div class="df jcc h-full f1 right xs:dn">
        <img class="usn" height="100%" src="https://img.phemex.com/v1/b4866f0a-4c04-4a1a-b39c-e7492553e404/frame-1000005793-1.png" alt="crypto trading platform" />
      </div>
    </div>
  </div>
</section>
